import type { Vault } from "../contexts/vault-types";

const VAULTS: { id: Vault; label: string }[] = [
  { id: "main", label: "Main" },
  { id: "health", label: "Health" },
  { id: "finance", label: "Finance" },
  { id: "work", label: "Work" },
  { id: "family", label: "Family" },
];

interface Props {
  selected: Vault[];
  onToggle: (v: Vault) => void;
}

export function VaultChipRow({ selected, onToggle }: Props) {
  return (
    <div className="flex gap-2 overflow-x-auto px-1 py-2">
      {VAULTS.map(v => {
        const on = selected.includes(v.id);
        return (
          <button
            key={v.id}
            onClick={() => onToggle(v.id)}
            className={
              "px-3 py-1 rounded-full text-xs font-semibold border whitespace-nowrap " +
              (on
                ? "bg-attic-accent text-white border-attic-accent"
                : "bg-attic-surface text-attic-dim border-attic-border dark:bg-[#2a2d33] dark:text-[#6a6e76]")
            }
          >
            {v.label}
          </button>
        );
      })}
    </div>
  );
}
